import React from 'react';
import _ from '@lodash';

const setIn = (state, name, value) => {
	return _.setWith(_.clone(state), name, value, _.clone);
};

function useForm(initialState: any, onSubmit?: () => void) {
	const [form, setForm] = React.useState(initialState);

	const handleChange = React.useCallback(event => {
		event.persist();
		setForm(_form =>
			setIn(
				{ ..._form },
				event.target.name,
				event.target.type === 'checkbox' ? event.target.checked : event.target.value
			)
		);
	}, []);

	const resetForm = React.useCallback(() => {
		if (!_.isEqual(initialState, form)) {
			setForm(initialState);
		}
	}, [form, initialState]);

	const setInForm = React.useCallback((name, value) => {
		setForm(_form => setIn(_form, name, value));
	}, []);

	const handleSubmit = React.useCallback(
		event => {
			event?.preventDefault();
			onSubmit?.();
		},
		[onSubmit]
	);

	return {
		form,
		handleChange,
		handleSubmit,
		resetForm,
		setForm,
		setInForm
	};
}

export default useForm;
